import { render, staticRenderFns } from "./TreeRow.vue?vue&type=template&id=2bfea4bd&scoped=true"
import script from "./TreeRow.vue?vue&type=script&lang=js"
export * from "./TreeRow.vue?vue&type=script&lang=js"
import style0 from "./TreeRow.vue?vue&type=style&index=0&id=2bfea4bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfea4bd",
  null
  
)

export default component.exports